section.match-section
  .home
  .visitor
  .menu-label
    .player
    .minute
  .scroll
